export const filterMessagesBot = (messages) => {
  const messagesFromBot = messages.filter(
    (message) => message.from === 'bot' && message.type !== 'TYPING'
  );

  return messagesFromBot;
};
